import { render, staticRenderFns } from "./package2.vue?vue&type=template&id=a68ba92c&scoped=true&"
import script from "./package2.vue?vue&type=script&lang=js&"
export * from "./package2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68ba92c",
  null
  
)

export default component.exports